import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { MailAccount } from "../../comunications/_types/mail-account";
import { CaseLogType } from "../../cases/_types/case-log-type";
import { CaseType } from "../../cases-types/_types/case-type";

export class ContractCaseType extends Resource {
    public override type = 'contractCaseTypes';

    @prop()
    @required()
    public contractId!: string;

    @prop()
    @required()
    public caseTypeId!: string;

    @prop()
    public caseType!: CaseType;

    @prop()
    public daysGuarantes!: number;

}